import React from "react"
import Checkbox from "src/shared/components/forms/checkbox/Checkbox"
import { getCurrencyFormat } from "src/utils/string"

const headersRS = ["Folio", "Detalle", "Precio", "Cantidad", "IVA", "Total", "Pagar"]
const headersEstancia = ["Folio", "Detalle", "Cantidad", "IVA", "Total", "Pagar"]

type TableProps = {
    data: any[][]
    checked: boolean[]
    onSelectionChange: (index: number) => void
    isEstancia?: boolean
}

export const Table = ({ data = [], checked, onSelectionChange, isEstancia = false }: TableProps) => {
    const headers = isEstancia ? headersEstancia : headersRS
    const rowClassName = `rs-pago__table-row${isEstancia ? " rs-pago__table-row--no-price" : ""}`
    const expandClassName = `rs-pago__table-cell rs-pago__table-cell-expand${isEstancia ? " rs-pago__table-cell-expand--no-price" : ""}`
    const itemClassName = `rs-pago__table-cell__item${isEstancia ? " rs-pago__table-cell__item--no-price" : ""}`

    return (
        <div className="rs-pago__table">
            <div className={`rs-pago__table-head ${rowClassName}`}>
                {headers.map((header, index) => (
                    <div key={index} className="rs-pago__table-title">
                        {header}
                    </div>
                ))}
            </div>

            <div className="rs-pago__table-content">
                {data?.map((row, rowIndex) => {
                    const isChecked = checked[rowIndex] || false
                    return (
                        <div className={`${rowClassName} rs-pago__table-row-body`} key={rowIndex}>
                            {row?.map((value, index) => {
                                return Array.isArray(value) ? (
                                    <div
                                        className={expandClassName}
                                        style={{ padding: 0 }}
                                        key={index}
                                    >
                                        {value.map(
                                            (
                                                { name = "", number = "", cost = 0, iva = 0, total = 0, extras = [] },
                                                itemIndex
                                            ) => (
                                                <React.Fragment key={itemIndex}>
                                                    <div className={itemClassName}>
                                                        <span>{name}</span>
                                                        {!isEstancia && <span>{getCurrencyFormat(cost)}</span>}
                                                        <span>{number}</span>
                                                        <span>{getCurrencyFormat(iva)}</span>
                                                        <span>{getCurrencyFormat(total)}</span>
                                                    </div>
                                                    {extras?.length > 0 &&
                                                        extras?.map((e: any, extraIndex: number) => (
                                                            <div className={itemClassName} key={extraIndex}>
                                                                <span style={{ paddingLeft: 30 }}>{e?.name}</span>
                                                                {!isEstancia && <span>{getCurrencyFormat(e?.cost)}</span>}
                                                                <span>{e?.number}</span>
                                                                <span>{getCurrencyFormat(e?.iva)}</span>
                                                                <span>{getCurrencyFormat(e?.total)}</span>
                                                            </div>
                                                        ))}
                                                </React.Fragment>
                                            )
                                        )}
                                    </div>
                                ) : (
                                    <div className="rs-pago__table-cell" key={index}>
                                        {value}
                                    </div>
                                )
                            })}

                            <div className="rs-pago__table-cell-check" key={row.length}>
                                <Checkbox
                                    value={isChecked}
                                    onChange={() => onSelectionChange(rowIndex)}
                                    iconColorWhenChecked="white"
                                />
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
